<script setup>
import SettingsForm from "@frontJs/components/forms/SettingsForm.vue";
import DefaultLayout from "@frontJs/layouts/DefaultLayout.vue";
import { Head } from "@inertiajs/vue3";
import PageTitle from "@js/components/titles/PageTitle.vue";
import { useI18n } from "vue-i18n";

const { googleAuthUrl, googleIsConnected, facebookConfiguration } = defineProps(
  {
    googleAuthUrl: {
      required: true,
      type: String,
    },
    googleIsConnected: {
      required: true,
      type: Boolean,
    },
    facebookConfiguration: {
      required: true,
      type: Object,
    },
  },
);

const { t } = useI18n();

defineOptions({ layout: DefaultLayout });
</script>

<template>
  <Head>
    <title>{{ t("title.settings") }} - {{ t("title.datakepler") }}</title>
  </Head>

  <PageTitle>
    {{ t("title.settings") }}
  </PageTitle>

  <SettingsForm
    :google-auth-url="googleAuthUrl"
    :google-is-connected="googleIsConnected"
    :facebook-configuration="facebookConfiguration"
  />
</template>
